type TRequirements = {
  mandatory?: string[] | null;
  priority?: string[] | null;
  optional?: string[] | null;
};

type TRequirementTags = {
  skills?: string[] | null;
  requirements?: TRequirements | null;
};

const cleanTags = (tags?: string[] | null): string[] => {
  return (tags ?? []).map((tag) => tag.trim()).filter(Boolean);
};

export const getRequirementTags = ({
  skills,
  requirements,
}: TRequirementTags): string[] => {
  const requirementTags = requirements
    ? cleanTags([
        ...(requirements.mandatory ?? []),
        ...(requirements.priority ?? []),
        ...(requirements.optional ?? []),
      ])
    : [];

  if (requirementTags.length) {
    return requirementTags;
  }

  return cleanTags(skills);
};

export const formatSalary = (
  salaryFrom?: number | string | null,
  salaryTo?: number | string | null,
) => {
  if (salaryFrom && salaryTo) {
    return `${salaryFrom} - ${salaryTo} ₽`;
  }

  if (salaryFrom) {
    return `${salaryFrom} ₽`;
  }

  if (salaryTo) {
    return `${salaryTo} ₽`;
  }

  return "";
};
